import { __assign } from "tslib";
// DS: C60
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ddt from '@wix/da-ddt';
import { Url } from '@wix/da-url';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import noop from '../../../../utils/noop';
import { ThemeOptions, ThemeOverride, } from '@wix/da-react-context/pkg/ThemeContext';
import Button from '../../../../Button';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import PremiumAssetList from '../../../../PremiumAssetList';
import DownloadOptions from './DownloadOptions';
import { useDownloadType, DownloadType } from './utils';
import s from './FreeAndPcpPopover.scss';
// TODO: there is a lot of overlap here with the PcpPopover, should probably make
// these two components reuse as much as possible
var FreeAndPcpPopover = function (_a) {
    var _b, _c;
    var deviation = _a.deviation, _d = _a.deviation, deviationId = _d.deviationId, _e = _d.extended, _f = _e === void 0 ? {} : _e, pcp = _f.pcp, download = _f.download, _g = _a.closeTooltip, closeTooltip = _g === void 0 ? noop : _g, _h = _a.onDownload, onDownload = _h === void 0 ? noop : _h;
    var t = useTranslation().t;
    var _j = useDownloadType(DownloadType.FREE), selectedType = _j.selectedType, setSelectedType = _j.setSelectedType;
    var checkoutUrl = ((_b = deviation.pcp) === null || _b === void 0 ? void 0 : _b.subproductId)
        ? Url.checkoutLink((_c = deviation.pcp) === null || _c === void 0 ? void 0 : _c.subproductId)
        : undefined;
    var _k = useSubscriptionTier(deviation), isInTier = _k.isInTier, isOwner = _k.isOwner, isUserSubscribed = _k.isUserSubscribed, subscriptionsTabUrl = _k.subscriptionsTabUrl;
    var hasAccessViaSubscription = isInTier && isUserSubscribed;
    var hasPurchased = (pcp === null || pcp === void 0 ? void 0 : pcp.hasUserPurchased) || hasAccessViaSubscription;
    var buttonHref;
    var isDownloadable = false;
    var buttonText = t('pcp.downloadNow');
    if (selectedType === DownloadType.FREE && !isInTier) {
        buttonHref = download === null || download === void 0 ? void 0 : download.url;
        isDownloadable = true;
    }
    else if (selectedType === DownloadType.FREE && isInTier) {
        var freeIsAccessible = isOwner || isUserSubscribed;
        buttonHref = freeIsAccessible ? download === null || download === void 0 ? void 0 : download.url : subscriptionsTabUrl;
        isDownloadable = freeIsAccessible;
        buttonText = freeIsAccessible
            ? buttonText
            : t('actionbar.download.mustSubscribe');
    }
    else if (selectedType === DownloadType.PREMIUM) {
        var premiumIsAccessible = isOwner || hasPurchased;
        buttonHref = premiumIsAccessible ? pcp === null || pcp === void 0 ? void 0 : pcp.url : checkoutUrl;
        isDownloadable = premiumIsAccessible;
        buttonText =
            isUserSubscribed || premiumIsAccessible
                ? buttonText
                : t('actionbar.download.mustPurchase');
    }
    var handleClick = useCallback(function (e) {
        isDownloadable && onDownload();
        closeTooltip(e);
    }, [isDownloadable, onDownload, closeTooltip]);
    // we don't need a popover if there's no pcp, just a download button
    if (!pcp) {
        ddt.alert('pcp', 'Showing the FreeAndPcpPopover while the pcp field on the relevant deviation is undefined. This should not happen.', ['pcp', 'download'], { deviation: deviation });
        return null;
    }
    return (React.createElement("div", { className: s['root'] },
        React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT },
            React.createElement("div", null,
                React.createElement("div", { className: s['title'] }, t('pcp.downloadDeviation')),
                React.createElement(DownloadOptions, { deviation: deviation, pcp: pcp, download: download, selectedType: selectedType, hasAccessViaSubscription: hasAccessViaSubscription, onSelect: setSelectedType })),
            React.createElement("div", null,
                React.createElement(PremiumAssetList, { assets: pcp.assets, muted: selectedType === DownloadType.FREE }),
                React.createElement(Button, __assign({ view: "b18", className: s['download-button'], disabled: selectedType === undefined, href: buttonHref }, (isDownloadable && {
                    target: '_blank',
                    download: true,
                }), { onClick: handleClick, biData: {
                        evid: BiEventType.DOWNLOAD_NOW_CLICK,
                        deviationid: deviationId,
                    } }), buttonText)))));
};
FreeAndPcpPopover.displayName = 'FreeAndPcpPopover';
export default FreeAndPcpPopover;
//# sourceMappingURL=FreeAndPcpPopover.js.map